module.exports = __webpack_public_path__ + "static/media/bhole.37cda36e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bhole.png
// module id = 110
// module chunks = 12